import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { Product } from "@/api/product-api";
import { ProductUtil } from "@/utils/ProductUtil";

type AccessoryType = "badge" | "non-badge";

export interface Accessory {
  slug: string;
  sku: string;
  quantity: number;
  selected: boolean;
  type: AccessoryType;
}

export const useBuyTactSuit = create<{
  products: Product[];
  product: Product | null;
  options: Array<{ type: string; value: string }>;
  gameResells: Array<{ id: string; platform: string }>;
  // Add to cart / Checkout 클릭 후 필수 옵션 미선택 시 true. 섹션 wrapper 의 연한 red 배경 트리거.
  showValidationErrors: boolean;

  accessories: {
    slug: string;
    sku: string;
    quantity: number;
    selected: boolean;
    type: AccessoryType;
  }[];
  getBadgeAccessories: () => Accessory[];
  getNonBadgeAccessories: () => Accessory[];
  getSku: () => string | null;
  setProducts: (products: Product[]) => void;
  setProduct: (product: Product) => void;
  setShowValidationErrors: (show: boolean) => void;
  reset: () => void;
  setOption: (option: { type: string; value: string }) => void;
  updateAccessory: ({ sku, slug, quantity, selected, type }) => void;
  initGameResells: (count: number) => void;
  toggleGameResell: (
    option: { id: string; platform: string },
    index: number,
  ) => void;
}>()(
  devtools(
    // persist(
    (set, get) => ({
      product: null,
      options: [],
      gameResells: [],
      accessories: [],
      showValidationErrors: false,
      setShowValidationErrors: (show) => set({ showValidationErrors: show }),
      getBadgeAccessories: () =>
        get().accessories.filter((a) => a.type === "badge"),
      getNonBadgeAccessories: () =>
        get().accessories.filter((a) => a.type === "non-badge"),
      updateAccessory: ({ sku, slug, quantity, selected, type }) =>
        set((state) => {
          const exists = state.accessories.find((p) => p.sku === sku);
          if (exists) {
            return {
              accessories: state.accessories.map((item) =>
                item.sku === sku ? { ...item, quantity, selected } : item,
              ),
            };
          }
          return {
            accessories: [
              ...state.accessories,
              { sku, slug, quantity, selected, type },
            ],
          };
        }),
      getSku: () => {
        const state = get();
        const { product, options, gameResells, products } = state;

        if (!product) return null;

        const { skuOptions } = product;
        if (skuOptions.length === 1) return skuOptions[0].sku;

        const bundleComponents = ProductUtil.getBundleComponents(
          products,
          product,
        );

        const skus = ProductUtil.getProductSkus({
          products: [product, ...bundleComponents],
          options,
          gameResells,
        });

        return ProductUtil.findProductSku({
          candidateSkus: skus,
          product,
        });
      },

      products: [],
      setProducts: (products) => set({ products }),
      setProduct: (product) => set({ product }),
      setOption: (option) =>
        set((state) => {
          const filtered = state.options.filter((o) => o.type !== option.type);
          return { options: [...filtered, option] };
        }),
      initGameResells: (count) =>
        set(() => ({
          gameResells: Array.from({ length: count }, () => ({
            id: "",
            platform: "",
          })),
        })),
      toggleGameResell: (option, index) =>
        set((state) => ({
          gameResells: state.gameResells.map((item, i) => {
            if (i === index) {
              return item?.id === option.id &&
                item?.platform === option.platform
                ? { id: "", platform: "" }
                : option;
            }
            return item;
          }),
        })),
      reset: () =>
        set({
          product: null,
          options: [],
          gameResells: [],
          accessories: [],
          showValidationErrors: false,
        }),
    }),
    { name: "TactSuitBuilder" },
    // ),
  ),
);
